import { SettingRow } from "./SettingRow";

export function SupportSettings(): JSX.Element {
  return (
    <div>
      <SettingRow
        label="Contact Us"
        description={<>For any questions or support, please email us at <span className="italic">support@breadhq.com</span></>}
      />
    </div>
  );
}
